// extracted by mini-css-extract-plugin
module.exports = {"all_center":"LfqDhT91","comp-wrapper":"__8YY6W4Zv","infiniteRotating":"__01xnxy8Y","fadeInOpacity":"viISd8GB"};